import { isUndefinedOrNullOrEmpty } from 'common/utils/isUndefinedOrNullOrEmpty';

class SocialSecurityListController {
  constructor() {
  }

  isEmpty() {
    return isUndefinedOrNullOrEmpty(this.ssData);
  }
}

export default SocialSecurityListController;



// WEBPACK FOOTER //
// ./client/app/social-security.module/features/socialSecurity/socialSecurityList/socialSecurityList.controller.js